export const regionHierarchyMap = {
  tokyoSpecialWards: [
    "131016", // 千代田区
    "131024", // 中央区
    "131032", // 港区
    "131041", // 新宿区
    "131059", // 文京区
    "131067", // 台東区
    "131075", // 墨田区
    "131083", // 江東区
    "131091", // 品川区
    "131105", // 目黒区
    "131113", // 大田区
    "131121", // 世田谷区
    "131130", // 渋谷区
    "131148", // 中野区
    "131156", // 杉並区
    "131164", // 豊島区
    "131172", // 北区
    "131181", // 荒川区
    "131199", // 板橋区
    "131202", // 練馬区
    "131211", // 足立区
    "131229", // 葛飾区
    "131237"  // 江戸川区
  ],

  tokyoNonSpecialWards: [
    "132012", // 八王子市
    "132021", // 立川市
    "132039", // 武蔵野市
    "132047", // 三鷹市
    "132055", // 青梅市
    "132063", // 府中市
    "132071", // 昭島市
    "132080", // 調布市
    "132098", // 町田市
    "132101", // 小金井市
    "132110", // 小平市
    "132128", // 日野市
    "132136", // 東村山市
    "132144", // 国分寺市
    "132152", // 国立市
    "132187", // 福生市
    "132195", // 狛江市
    "132209", // 東大和市
    "132217", // 清瀬市
    "132225", // 東久留米市
    "132233", // 武蔵村山市
    "132241", // 多摩市
    "132250", // 稲城市
    "132276", // 羽村市
    "132284", // あきる野市
    "132292", // 西東京市
    "133035", // 瑞穂町
    "133051", // 日の出町
    "133078", // 檜原村
    "133086", // 奥多摩町
    "133612", // 大島町
    "133621", // 利島村
    "133639", // 新島村
    "133647", // 神津島村
    "133817", // 三宅村
    "133825", // 御蔵島村
    "134015", // 八丈町
    "134023", // 青ヶ島村
    "134210"  // 小笠原村
  ]
}